
import { useQueryWithConfig } from "../useQueryWithConfig";
import { services } from '@repo/ui/lib/api/services/index';
export function useInventories(page: number, limit: number, search?: string) {
    const keys = ["inventaires",page,limit,search].filter(key=> key != undefined)
    return useQueryWithConfig(
        keys,
      () => services.inventory.getInventaireFinished(page,limit, search)
    );
  }
